import { useState } from "react";

export const UserAvatar = ({ user, size = 28, className = "" }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const initials = ((user?.name || user?.email || "?").trim()[0] || "?").toUpperCase();

  if (user?.picture && !imgFailed) {
    return (
      <img
        src={user.picture}
        alt={user.name || user.email || "User"}
        referrerPolicy="no-referrer"
        onError={() => setImgFailed(true)}
        className={`rounded-full object-cover shrink-0 ${className}`}
        style={{ width: size, height: size }}
        data-testid="user-avatar-img"
      />
    );
  }
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-orange-100 text-orange-700 font-semibold shrink-0 ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.45) }}
      data-testid="user-avatar-initials"
    >
      {initials}
    </span>
  );
};

export default UserAvatar;
